import React from 'react';
import { View, TouchableWithoutFeedback } from 'react-native';
import { ThemedView, ThemedText } from '@app/theme';

interface GujaratToolTipProps {
    onClose: () => void;
}

const GujaratToolTip: React.FC<GujaratToolTipProps> = ({ onClose }) => (
    <TouchableWithoutFeedback onPress={(e) => e.stopPropagation()}>
        <ThemedView
            position="absolute"
            top={26}
            right={-10}
            backgroundColor="white"
            padding={"md"}
            borderColor={"border-primary"}
            borderWidth={1}
            borderRadius={"sm"}
            zIndex={9999}
            width={220}
            shadowColor="black"
            shadowOffset={{ width: 0, height: 2 }}
            shadowOpacity={0.25}
            shadowRadius={4}
            elevation={10}
            style={{
                shadowColor: 'rgba(0, 0, 0, 0.17)',
                shadowOffset: { width: 0, height: 0 },
                shadowOpacity: 1,
                shadowRadius: 17,
                backgroundColor: 'white',
              }}
        >
            <ThemedText variant="b4s" color="text-primary" numberOfLines={1}>
                Stamp duty fee for Gujarat
            </ThemedText>
            <ThemedText variant="b5r" color="text-primary">
                {"For credit limits up to 10 crore: \n • ₹600 + 0.25% of the credit limit. \n For credit limits exceeding 10 crore:\n • ₹600 + 0.50% of the credit limit."}
            </ThemedText>
            {/* Arrow pointing up to the info icon */}
            <View style={{
                position: 'absolute',
                top: -8,
                right: 10,
                width: 0,
                height: 0,
                backgroundColor: 'transparent',
                borderStyle: 'solid',
                borderTopWidth: 0,
                borderRightWidth: 8,
                borderBottomWidth: 8,
                borderLeftWidth: 8,
                borderTopColor: 'transparent',
                borderRightColor: 'transparent',
                borderBottomColor: 'white',
                borderLeftColor: 'transparent',
            }}/>
        </ThemedView>
    </TouchableWithoutFeedback>
);

export default GujaratToolTip;